import React, { useEffect, useState } from "react";
import BeginButton from "./ui/BeginButton";
import { useDispatch, useSelector } from "react-redux";
import BigWhitePlus from "graphics/icons/HomeStart/BigWhitePlus.js";
import StartModal from "./ui/StartModal";
import RootSetup from "./RootSetup/RootSetup";
import { selectNewRootModal, setNewRootModal } from "slices/homeStartSlice";
import JoinWithLink from "./JoinWithLink/JoinWithLink";
import JoinEffice from "graphics/icons/HomeStart/JoinEffice";
import {
  FM_JOINORCREATE,
  isFreshman,
  startHomeHelpers,
} from "helpers/freshman";
import HelperTip from "components/HOCS/HelperTip";
import HlpJoinOrCreate from "components/HelpSlides/Home/HlpJoinOrCreate";

const HomeStart = () => {
  const [joinModal, setJoinModal] = useState(false);
  const newRootModal = useSelector(selectNewRootModal);
  const dispatch = useDispatch(setNewRootModal);
  useEffect(() => {
    // FOR FRESHMAN HELEPERS
    let intTimeout = null;
    if (isFreshman()) {
      intTimeout = setTimeout(() => {
        startHomeHelpers();
      }, 2000);
    }
    return () => {
      dispatch(setNewRootModal({ status: null }));
      clearTimeout(intTimeout);
      setJoinModal(false);
    };
  }, [dispatch]);
  return (
    <div className="home-start">
      {joinModal ? (
        <StartModal
          onDismiss={() => {
            setJoinModal(false);
          }}
          lightBackDrop={true}
          growth={false}
          header={<div>Join an Effice with an invite link</div>}
          content={<JoinWithLink />}
          actions={null}
          noBackDropClick={true}
        ></StartModal>
      ) : null}
      {newRootModal ? (
        <StartModal
          onDismiss={() => {
            dispatch(setNewRootModal({ status: false, effice: null }));
          }}
          lightBackDrop={true}
          growth={true}
          header={<div>Create a New Effice</div>}
          content={<RootSetup />}
          actions={null}
          noBackDropClick={true}
        ></StartModal>
      ) : null}
      <HelperTip
        code={FM_JOINORCREATE}
        placement="top"
        style={{ width: "275px" }}
        component={<HlpJoinOrCreate />}
      >
        <div>
          <BeginButton
            onClick={() => setJoinModal(true)}
            type="business"
            text={
              <>
                Join <br /> With Link
              </>
            }
          >
            <JoinEffice />
          </BeginButton>
        </div>
      </HelperTip>

      <div>
        <BeginButton
          onClick={() => {
            dispatch(setNewRootModal({ status: true, effice: null }));
          }}
          type="growth"
          text="Create Effice"
        >
          &nbsp;&nbsp;
          <BigWhitePlus />
        </BeginButton>
      </div>
    </div>
  );
};

export default HomeStart;
